import { canonicalSlotValue, slotKey } from "./softoneSlotSync";

export const ERGANI_MARK = Object.freeze({
  HIDDEN: "hidden",
  MISSING: "missing",
  MATCH: "match",
  DRIFT: "drift",
});

/** Rest in Ergani (ΑΝ) lines up with Internal OFF. Work hours compare as HH:MM-HH:MM. */
export function erganiComparableValue(row) {
  if (!row) return "";
  const type = String(row.day_type || "").trim();
  const shift = String(row.shift_value || "").trim();
  if (type === "ΑΝ" || shift === "ΑΝ") return "OFF";
  if (type === "ΕΡΓ") return canonicalSlotValue(shift);
  return shift;
}

export function erganiMarkerState(internalValue, erganiRow) {
  const internal = canonicalSlotValue(internalValue);
  if (!erganiRow) {
    return internal ? ERGANI_MARK.MISSING : ERGANI_MARK.MATCH;
  }
  const published = erganiComparableValue(erganiRow);
  if (internal === published) return ERGANI_MARK.MATCH;
  return ERGANI_MARK.DRIFT;
}

export function erganiMarkerLabel(state, lang) {
  const gr = lang === "gr";
  if (state === ERGANI_MARK.MATCH) return gr ? "Στο Εργάνη" : "In Ergani";
  if (state === ERGANI_MARK.MISSING) return gr ? "Όχι στο Εργάνη" : "Not in Ergani";
  if (state === ERGANI_MARK.DRIFT) return gr ? "Διαφέρει από το Εργάνη" : "Differs from Ergani";
  return "";
}

export function indexErganiSlots(slots) {
  const map = {};
  (slots || []).forEach((row) => {
    const code = String(row.employee_code || "").trim();
    const date = String(row.date || row.rota_date || "").slice(0, 10);
    if (!code || !date) return;
    map[slotKey(code, date)] = row;
  });
  return map;
}
